export enum AssignmentStatusEnum {
  CREATED = 1,
  TAKEN = 2,
  DONE = 3,
}
